<template>
  <div class="upload-box">
    <div class="upload-btn" id="uploadBtnDiv">
          <ejs-button class="e-input" isPrimary='true' @click.native='upButton' >{{$t("Common.upload")}}</ejs-button>
    </div>
    <progress-bar v-show='showProgressBar' ref='progressBar' :val='progressVal' :text='progressText' class="upload-progress"></progress-bar>
    <div class='h-system-hide-upload'>
      <ejs-uploader ref='file' name='file' id='file' autoUpload='false' :selected='onFileSelect'
                    :allowedExtensions='extensions'
                    :multiple='false'></ejs-uploader>
    </div>
  </div>
</template>


<script>
  import ProgressBar from 'vue-simple-progress';
  import { EventBus } from '../../../plugins/eventBus';
  export default {
    name: 'addDialog',
    components: {
      ProgressBar
    },
    data() {
      return {
        extensions: '.tar.gz,.zip,.pkg',
        showProgressBar: false,
        progressVal: 0,
        progressText: '0%',
        versionShow: false,
        dataSource: [
          {text: this.$t('基础'), value: 0},
          {text: this.$t('业务'), value: 1},
        ],
        deliverType: [
          {text: 'Native', value: 0},
          {text: 'Image', value: 1},
          {text: 'Helm', value: 2},
          {text: 'VM', value: 3}
        ],
        versionSource: [],
        brokenFlag:0,
        dataList:[]
      }
    },
    methods: {
      upButton() {
        document
          .getElementsByClassName('e-file-select-wrap')[0]
          .querySelector('button')
          .click();
        return false;
      },
      setCancel(param){
        this.brokenFlag = param;
      },
      async onFileSelect(args) {
        this.tryUtilFileLoaded();
      },
      tryUtilFileLoaded(){
        setTimeout(() => {
          try {
            const uploadPrefix = this.randomId();
            this.bigFileUpload(uploadPrefix);
          } catch (error) {
            this.tryUtilFileLoaded();
          }
        }, 100);
      },
      randomId() {
        const _temp = 'abcdefghijklmnopqrstuvwxyz';
        let randStr = '';
        for (let i = 0; i <= 8; i++) {
          randStr += _temp[Math.round(Math.random(1) * 26)];
        }
        return randStr;
      },
      getVersionList() {
        // 获取适配包版本号
        const url = '/lte/ems/packageManager/queryService';
        this.axios.get(url).then(res => {
          console.log(res.data);
          const list = res.data.map(item => item.pkgVersion);
          this.versionSource = Array.from(new Set(list));
        });
      },
      getParam() {
        // const index = this.$refs.versionList.ej2Instances.index;
        // const version = this.versionSource[index];
        let type = 0;
        // const radioGroup = document.getElementsByName('DeliverRadio');
        // radioGroup.forEach(item => {
        //   if(item.checked) {
        //   type = item.ej2_instances[0].value;
        //   }
        // });
        const file = this.$refs.file.ej2Instances.filesData[0];
        const param = {
          // version: version,
          file: file['rawFile'],
          fileType:file['type'],
          type: type
        };
        return param;
      },
      /*check() {
        const data = this.getParam();
        const file = data['file'];
        const version = data['version'];
        if (file.name.indexOf('.pkg') != -1 && version == null) {
          this.eventEmit('warning', '请选择适配包匹配版本号');
          return false;
        }
        return true;
      },*/
      async checkExistPackage(){
        const url = '/lte/ems/packageManager/isPackageExist';
        const data = this.getParam();
        const fileName = data['file']['name'];
        const params = {
          fileName: fileName
        };
        let exist = new Boolean();
        await this.axios.get(url, { params }).then(res => {
          exist = res.data;
        });
        return exist;
      },
      eventEmit(type, content) {
        EventBus.$emit('toast', {type: type, content: content})
      },
      async bigFileUpload(uploadPrefix) {
        // 进度条
        this.brokenFlag = 0;
        const data = this.getParam();
        const srcFile = data['file'];
        // 如果文件为空，则退出
        if(!srcFile){
          this.eventEmit('warning', this.$t('System.fileNotNull'));
          return null;
        }
        if(data['fileType'] != 'gz' && data['fileType'] != 'zip' && data['fileType'] != 'pkg'){
          this.eventEmit('warning', this.$t('DeployManagement.invalidPackage'));
          return;
        }
        /*if(srcFile.name.lastIndexOf(".lnk") != -1 || srcFile.name.lastIndexOf(".url") != -1){
          this.eventEmit('warning', this.$t('DeployManagement.invalidPackage'));
          return;
        }*/
        // 检查该文件是否上传过
        /*const isExist = await this.checkExistPackage();
        if (isExist) {
          this.eventEmit('warning', this.$t('DeployManagement.pkgExists'));
          return;
        }*/
        for(let i = 0; i < this.dataList.length; i++){
            if(this.dataList[i].packageName == this.$refs.file.ej2Instances.filesData[0].name){
               this.eventEmit('warning', this.$t('DeployManagement.hasSameAdapterPackage'));
               return;
            }
        }

        document.getElementById("uploadBtnDiv").style.display="none";
        EventBus.$emit("setChildProps", {status:0});
        const tempFiles = [];
        // 每片5M
        const perPiece = 1024 * 1024 * 50;
        let originalFilePath = '';
        let start = 0;
        let end = 0;
        let index = 0;
        let totalPieces = 0;
        let filesize = srcFile.size;
        let filename = srcFile.name;
        // 计算文件切片总数
        totalPieces = filesize % perPiece == 0 ? filesize/perPiece : filesize/perPiece + 1;
        // 上传文件
        const url = '/lte/ems/packageManager/bigFilePiece';
        const config = {
          headers: {
            "Content-Type": "multipart/form-data"
          },
          processData: false,
          async: false,
          contentType: false,
          timeout: 60 * 30 * 1000
        };
        let pecent = 0;
        this.showProgressBar = true;
        while((start < filesize) && this.brokenFlag == 0) {
          // 切片上传
          end = start + perPiece;
          if(end > filesize) {
            // 一次性上传
            end = filesize;
          }
          // 分割文件核心部分slice
          const chunk = srcFile.slice(start, end);
          const formData = new FormData();
          formData.append("file", chunk, filename);
          formData.append("totalPieces", totalPieces);
          formData.append("index", index);
          formData.append("process", pecent);
          formData.append("prefix", uploadPrefix);
          await this.$axios.post(url, formData, config).then(response => {
            const result = response['data']['resultVal'];
            tempFiles.push(result['msg']);
            originalFilePath = result['message'];
            // // 进度条
            pecent=(100*(end)/filesize).toFixed(2);
            if(pecent>=100){
              pecent=100.00;
            }
            this.progressVal = pecent;
            this.progressText = pecent + '%';
          });
          start = end;
          index ++;
        }
        if(this.brokenFlag == 0){
          this.mergeBigFile(tempFiles, originalFilePath, uploadPrefix, filename);
        }else{
          this.clearCancelTempFile(uploadPrefix);
        }
      },
      clearCancelTempFile(prefix){
        const url = '/lte/ems/packageManager/clearCancelTempFile';
        const param = {
          prefix: prefix
        };
        this.$axios.post(url, param).then(res => {
          console.log("clear cancel tempFile...");
        });
      },
      mergeBigFile(tempFiles, originalFilePath, taskId, filename) {
        const url = '/lte/ems/packageManager/mergeBigFile';
        const param = {
          tempFiles: tempFiles,
          originalFilePath: originalFilePath
        };
        this.progressText = this.$t('DeployManagement.mergeBigFile');
        this.$axios.post(url, param, {timeout: 60 * 15 * 1000}).then(res=> {
          if(res.data.errorCode == 'SUCCESS'){
            const data = this.getParam();
            console.log("data file.....", data);
            if(data['file']['name'].indexOf("eMS_NeAdapter_") > -1 || data['fileType'] == "pkg"){
              this.progressText = this.$t('System.processing');
              this.sendUpload(originalFilePath);
            }else{
              this.progressText = this.$t('DeployManagement.uploading');
              this.sendUpload(originalFilePath, taskId, filename);
            }
          }else{
            this.progressText = res.data.errorString;
          }
          EventBus.$emit("setChildProps", {status:1});
        });

      },
      sendUpload(originalFilePath, taskId, filename){
        const url = '/lte/ems/packageManager/uploadPackage';
        const param = {
          filePath: originalFilePath,
          taskId:taskId
        };
        this.$axios.post(url, param, {timeout: 60 * 5 * 1000}).then(res => {
          if(res.data.errorCode == 'SUCCESS'){
            this.progressText = this.$t('DeployManagement.uploadFinish');
          }else{
            this.progressText = res.data.errorString;
          }
        });
        if(taskId){
          const pkgList = [];
          pkgList.push(filename);
          EventBus.$emit("qryProgress", {taskId:taskId, pkgList:pkgList});
        }
      }
    }, mounted() {
    EventBus.$on('curAdapterList', (data) => {
      this.dataList = data;
    });
   },
    destroyed() {
      this.brokenFlag = 1;
    }
  }
</script>
